import { defaultTransformFn, dsApi } from "api/rtkQueryApi/DsApi";
import {Invoice} from "../entities/Invoice";

const invoicesTags = dsApi.enhanceEndpoints({ addTagTypes: ["Invoices"] });

const invoicesApi = invoicesTags.injectEndpoints({
    endpoints: (build) => ({
        invoicesGetAll: build.query<Invoice[], void>({
            query: () => {
                return {
                    url: `invoices`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: () => [{type: "Invoices"}],
        }),
        invoicesGetForBusiness: build.query<Invoice[], { businessId: string }>({
            query: ({businessId}) => {
                return {
                    url: `invoices/business/${businessId}`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: () => [{type: "Invoices"}],
        })
    }),
});

export const {
    useInvoicesGetAllQuery,
    useInvoicesGetForBusinessQuery
} = invoicesApi;
